import React from 'react';
export var DeviationViewMode = /*#__PURE__*/ function(DeviationViewMode) {
    DeviationViewMode["Theater"] = "theater";
    DeviationViewMode["Fullscreen"] = "fullscreen";
    DeviationViewMode["Normal"] = "regular";
    return DeviationViewMode;
}({});
export const SessionContext = /*#__PURE__*/ React.createContext({
    isLoggedIn: false
});
SessionContext.displayName = 'SessionContext';

//# sourceMappingURL=SessionContext.js.map